<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <i-card-vertical
        :headerTitle="scenarioData.__created__ ? '비상대응 매뉴얼 관리 추가' : '비상대응 매뉴얼 관리 상세'"
        :IsUseEditorBox="selectedKey === 1"
        device="web"
      >
        <template v-slot:EditorBox>
          <v-row no-gutters class="justify-end align-center">
            <v-col style="width: 200px">
              <i-date-time-picker
                :firstDisplayDate="startDate"
                placeholder="시작일자"
                class="mx-1"
                bgcolor="white"
                :dateOnly="true"
                :menu="true"
                :functionEvents="functionEvents"
                @getDate="setSearchDate($event, 'start')"
                :allowMaxDate="searchMaxDate"
              ></i-date-time-picker>
            </v-col>
            <span class="inner_active_menu--text">~</span>
            <v-col style="width: 200px">
              <i-date-time-picker
                :firstDisplayDate="endDate"
                placeholder="종료일자"
                class="mx-1"
                bgcolor="white"
                :dateOnly="true"
                :menu="true"
                :functionEvents="functionEvents"
                @getDate="setSearchDate($event, 'end')"
                :allowMinDate="searchMinDate"
              ></i-date-time-picker>
            </v-col>
          </v-row>
        </template>
        <template v-slot:body>
          <v-sheet class="tab-layout">
            <!-- 좌측 tab -->
            <v-card color="inner_card_bg" class="overflow-y-auto">
              <v-list class="pa-0 contents-menu">
                <v-list-item-group>
                  <v-list-item
                    v-for="(item, index) in tabList"
                    :key="item.index"
                    :class="{
                      active: item.id == selectedKey,
                      'guide-blink-target': guideHighlightTab && item.id === 1,
                    }"
                    @click="subMenuChanged(index)"
                  >
                    <v-list-item-content>
                      <div v-html="item.name" />
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>

            <!-- 우측 테이블 영역 -->
            <!-- table -->
            <v-card class="overflow-y-auto" :class="breakpoint === 'md' || breakpoint === 'sm' || breakpoint === 'xs' ? 'mt-5' : ''">
              <form v-show="selectedKey === 0" :key="componentKey">
                <v-row no-gutters>
                  <v-col cols="2">
                    <v-btn
                      v-if="scenarioData.signWriterHrNo && scenarioData.signApproverHrNo"
                      @click="btnTrainingFcm"
                      elevation="0"
                      color="primary"
                      small
                      class="ml-1 grid-btn"
                      >훈련 알림 발송</v-btn
                    >
                  </v-col>
                  <v-col cols="10">
                    <!-- 비상대응 매뉴얼 tab -->
                    <sign
                      v-if="selectedKey === 0"
                      :key="componentKey"
                      ref="scenario"
                      :items="signatureListUser.scenario"
                      :signature="signatureList.scenario"
                      :editable="signEditable"
                      :guide-highlight="guideHighlightSign"
                      @signChanged="signChanged"
                    ></sign>
                  </v-col>
                </v-row>
                <v-form ref="scenarioForm">
                  <v-simple-table class="mt-5 custom-table">
                    <template v-slot:default>
                      <colgroup>
                        <col style="width: 5%" />
                        <col style="width: 10%" />
                        <col style="width: 10%" />
                        <col style="width: 25%" />
                        <col style="width: 30%" />
                        <col style="width: 20%" />
                      </colgroup>
                      <tbody>
                        <tr>
                          <td colspan="3" class="text-center tableTitle required">비상사태명</td>
                          <td colspan="3">
                            <v-text-field
                              v-model="scenarioData.trainingNm"
                              :rules="rules"
                              solo
                              hide-details="auto"
                              placeholder="비상사태명을 입력하세요."
                            />
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-center tableTitle required">장소</td>
                          <td colspan="3">
                            <v-text-field
                              v-model="scenarioData.trainingLocation"
                              :rules="rules"
                              solo
                              hide-details="auto"
                              placeholder="비상사태 발생 장소를 입력하세요."
                            />
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-center tableTitle required">발생 내용</td>
                          <td colspan="3">
                            <v-textarea
                              v-model="scenarioData.trainingContent"
                              :rules="rules"
                              rows="1"
                              row-height="5"
                              solo
                              no-resize
                              auto-grow
                              spellcheck="false"
                              hide-details="auto"
                              placeholder="비상사태 발생 내용을 입력하세요."
                            />
                          </td>
                        </tr>
                        <tr>
                          <td colspan="3" class="text-center tableTitle">
                            예상되는 피해
                            <br />(안전보건영향)
                          </td>
                          <td colspan="3">
                            <v-text-field
                              v-model="scenarioData.anticipatedDamage"
                              solo
                              hide-details="auto"
                              placeholder="비상사태 발생 시 예상되는 피해를 입력하세요."
                            />
                          </td>
                        </tr>
                        <tr>
                          <td v-if="isCanEdit" class="text-center tableTitle" style="width: 3%">
                            <!-- <v-btn @click="subtractScenario('clearAll')" icon>
                              <v-icon>mdi-minus-circle</v-icon>
                            </v-btn>-->
                            <v-btn color="error" icon @click="subtractScenario('clearAll')">
                              <svg-icon icon-class="minus" style="height: 20px" />
                            </v-btn>
                          </td>
                          <td :colspan="isCanEdit ? 1 : 2" class="text-center tableTitle required">상황(경과)</td>
                          <td class="text-center tableTitle required">경과시간</td>
                          <td class="text-center tableTitle">임무수행</td>
                          <td class="text-center tableTitle">행동요령</td>
                          <td class="text-center tableTitle">비고</td>
                        </tr>
                        <tr v-if="scenarioList.length === 0" style="height: 60px">
                          <td colspan="6" class="text-center font-weight-bold error--text">
                            {{ '행동요령이 존재하지 않습니다. + 버튼을 눌러 항목을 추가하세요.' }}
                          </td>
                        </tr>
                        <tr v-for="(row, index) in scenarioList" :key="index">
                          <td v-if="isCanEdit" class="text-center">
                            <v-btn color="error" icon @click="subtractScenario(index)">
                              <svg-icon icon-class="minus" style="height: 20px" />
                            </v-btn>
                          </td>
                          <td :colspan="isCanEdit ? 1 : 2" width="2%">
                            <div class="table-cell text-center">
                              <v-text-field
                                v-model.number="row.situation"
                                :rules="rules"
                                type="text"
                                solo
                                hide-details="auto"
                                @change="onValueChanged($event, index)"
                              ></v-text-field>
                            </div>
                          </td>
                          <td class="text-right" width="3%">
                            <div class="table-cell text-center">
                              <v-text-field
                                class="right-aligned"
                                v-model.number="row.targetTime"
                                :rules="rules"
                                type="text"
                                oninput="this.value = this.value.replace(/[^0-9.]/g, '')"
                                solo
                                hide-details="auto"
                                suffix="분"
                                min="0"
                                max="300"
                                @change="onValueChanged($event, index)"
                              ></v-text-field>
                            </div>
                          </td>
                          <td>
                            <div class="table-cell">
                              <v-text-field
                                v-model="row.performer"
                                rows="1"
                                row-height="5"
                                solo
                                no-resize
                                auto-grow
                                spellcheck="false"
                                hide-details="auto"
                              />
                            </div>
                          </td>
                          <td>
                            <div class="table-cell">
                              <v-textarea
                                v-model="row.methodAction"
                                rows="1"
                                row-height="5"
                                solo
                                no-resize
                                auto-grow
                                spellcheck="false"
                                hide-details="auto"
                                placeholder="비상사태 대응 행동요령을 입력하세요."
                              />
                            </div>
                          </td>
                          <td>
                            <div class="table-cell">
                              <v-textarea
                                v-model="row.remark"
                                rows="1"
                                row-height="5"
                                solo
                                no-resize
                                auto-grow
                                spellcheck="false"
                                hide-details="auto"
                              />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-form>
                <div v-if="isCanEdit" class="mt-2 mb-10 d-flex justify-center align-center">
                  <v-btn elevation="0" width="100%" height="48" class="table-add-btn" @click="addScenario">
                    <svg-icon icon-class="plus" style="height: 20px" />
                  </v-btn>
                </div>
                <iFileManage
                  ref="iFileUploader"
                  :targetId="targetId"
                  targetType="00012"
                  @onFileChanged="onFileChanged"
                  class="mt-5"
                  :fileExtension="allowedFileExtensions.join(',')"
                />
              </form>
              <div v-show="selectedKey === 1">
                <!-- <div class="d-flex justify-end">
                  <v-col cols="3" md="3" class="row pa-0 d-flex align-center">
                    <sign
                      v-if="selectedKey === 1"
                      ref="implementationReport"
                      :items="signatureListUser.implementationReport"
                      :signature="signatureList.implementationReport"
                      :editable="signEditable"
                      @signChanged="signChanged"
                    ></sign>
                  </v-col>
                </div>-->

                <!-- 비상훈련 실시보고서 테이블 -->
                <v-card
                  v-for="(list, index) in resultList"
                  :key="`${list.docNo}_${index}`"
                  width="100%"
                  height="100%"
                  class="addable-card d-flex"
                  :class="{ 'mt-3': index !== 0 }"
                >
                  <div class="addable-left">
                    <v-checkbox
                      v-model="list.checked"
                      :true-value="true"
                      :false-value="false"
                      hide-details
                      class="my-4"
                      @click="checkResult(index, list.checked)"
                    ></v-checkbox>
                    <v-divider width="100%"></v-divider>
                    <v-btn
                      text
                      height="calc(100% - 84px)"
                      class="rounded-pill ma-3 pa-2"
                      :color="list.signWriterHrNo || list.signApproverHrNo ? 'disabled' : 'error'"
                      @click="subtractResult(index)"
                      :key="componentKey"
                    >
                      <svg-icon v-if="list.signWriterHrNo || list.signApproverHrNo" icon-class="minusDisabled" style="height: 20px" />
                      <svg-icon v-else icon-class="minus" style="height: 20px" />
                    </v-btn>
                  </div>
                  <v-card width="100%" class="pa-4 addable-contents">
                    <resultTable
                      ref="resultTable"
                      :resultData="list"
                      :duplicatedActDt="duplicatedActDt"
                      :guide-highlight="guideHighlightSign"
                      @signChanged="signChanged"
                    ></resultTable>
                  </v-card>
                </v-card>
                <div class="mt-2 mb-10 d-flex justify-center align-center">
                  <v-btn
                    @click="addResult"
                    width="100%"
                    height="48"
                    class="table-add-btn"
                    :class="{ 'guide-blink-target': guideHighlightAdd }"
                    elevation="0"
                  >
                    <svg-icon icon-class="plus" style="height: 20px" />
                  </v-btn>
                </div>
              </div>
            </v-card>
          </v-sheet>
        </template>
        <template v-slot:drawer>
          <v-navigation-drawer v-model="procedureShow" width="75%" absolute right temporary class="feedback-area">
            <ProcedureComponent :type="'00006'" />
          </v-navigation-drawer>
        </template>
      </i-card-vertical>
      <v-sheet class="iCardRightWrap">
        <i-card-right
          :key="btnRefresh"
          :useBtnList="buttonUseList"
          @btnSample="btnSampleLoad()"
          @btnSearch="btnSearch(mainData)"
          @btnSave="btnSave()"
          @btnPrint="btnPrint"
          @btnDelete="btnDelete()"
        >
          <template v-slot:customBtn>
            <!-- <v-btn v-show="selectedKey === 0" color="btn_sub" elevation="0" dark small @click="btnSampleLoad()" class="rounded">예시 보기</v-btn> -->
            <i-icon-button
              color="btn_text"
              :text="'목록으로'"
              height="92px"
              :icon="'back'"
              @click="btnCancel()"
              :appendDivider="true"
            ></i-icon-button>
          </template>
        </i-card-right>
        <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button
              v-if="selectedKey === 1"
              color="btn_text"
              :text="'근로자 확인'"
              :icon="'check'"
              :appendDivider="true"
              @click="checkHrNo()"
            ></i-icon-button>
            <i-icon-button color="btn_text" :text="'절차서'" :icon="'file'" @click="procedureShow = !procedureShow"></i-icon-button>
          </template>
        </i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>
<script>
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import iCardTop from '@/components/common/iCardTop.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import IDateTimePicker from '@/components/common/iDateTimePicker.vue'
import sign from '@/components/sign/sign.vue'
import iFileManage from '@/components/esgCommon/iFileManage.vue'
import resultTable from './EmergencyResponseTrainingResult.vue'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'
// utils
import { getCurrentDate } from '@/utils/common.js'
import { AesEncrypt, AesDecrypt } from '@/utils/aes256'
import { getPreMonth, getYearFormat } from '@/utils/common.js'
// API
import {
  getTrainingScenarioSampleData,
  getEmergencyResponseTrainingScenario,
  getEmergencyResponseTrainingResult,
  getTrainingResultDateList,
  saveEmergencyResponseTrainingScenario,
  saveEmergencyResponseTrainingResult,
  deleteEmergencyResponseTraining,
  deleteEmergencyResponseTrainingResult,
  updateEmergencyResponseTrainingResultLook,
  updateScenarioSign,
  updateResultSign,
  sendFCMTraining,
  getTrainingScenarioReport,
  getTrainingResultReport,
  checkEmergencyResponseTrainingResultLook,
} from '@/api/emergencyActionPlan/emergencyResponseTraining.js'
export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가 및 권한 처리
  name: 'EmergencyResponseTrainingDetail',
  components: {
    'i-card-vertical': iCardVertical,
    'i-card-top': iCardTop,
    IDateTimePicker,
    sign,
    iFileManage,
    resultTable,
    ProcedureComponent,
  },

  data() {
    return {
      componentKey: 0,
      initCompId: '',
      startDate: getPreMonth(3),
      endDate: getPreMonth(-3),
      searchStartDate: getPreMonth(3).replace(/[^0-9]/g, ''),
      searchEndDate: getPreMonth(-3).replace(/[^0-9]/g, ''),
      searchMinDate: getPreMonth(3),
      searchMaxDate: getPreMonth(-3),
      dateList: [],
      rules: [
        (value) => {
          if (value) return true
          return '필수입력 값입니다.'
        },
      ],
      allowedFileExtensions: ['.jpg', '.jpeg', '.png', '.pdf'],
      buttonUseList: [
        'btnSample', // 예시보기
        'btnSearch', //조회
        'btnSave', //저장
        'btnPrint',
        'btnDelete',
      ],
      mainData: {},
      scenarioData: {},
      resultData: {},
      actionDt: false,
      selectedKey: 0,
      btnRefresh: 0,
      tabList: [
        {
          id: 0,
          name: '비상대응 매뉴얼',
        },
        {
          id: 1,
          name: '비상대응 결과 보고서',
        },
      ],
      signatureList: {
        scenario: [
          {
            data: '',
            userNm: '',
          },
          {
            data: '',
            userNm: '',
          },
          {
            data: '',
            userNm: '',
          },
        ],
      },
      signatureListUser: {
        scenario: [
          {
            subMenu: 'scenario',
            header: '작성자',
            headerCd: 'signWriterHrNo',
            authList: ['supervisor', 'safety_manager', 'work_manager'], // 안전보건관리책임자, 현장안전관리자, 관리감독자
          },
          {
            subMenu: 'scenario',
            header: '승인자',
            headerCd: 'signApproverHrNo',
            authList: ['supervisor'], // 안전보건관리책임자
          },
          {
            subMenu: 'scenario',
            header: '확인자',
            headerCd: 'signCheckerHrNo',
            authList: ['ceo'],
          }, // CEO
        ],
      },
      signEditable: true,
      scenarioList: [],
      resultList: [], // 에디팅 작업을 위한 리스트화
      targetId: '',
      fileList: {
        insert: [],
        delete: [],
      },
      duplicatedActDt: [], // 훈련일자 date picker에서 막기 위해 넘기는 변수
      procedureShow: false,
      guideHighlightSign: false, // 반기평가 이동 시 서명란 깜빡임 (매뉴얼 탭)
      guideHighlightTab: false, // 반기평가 이동 시 결과 보고서 탭 깜빡임
      guideHighlightAdd: false, // 반기평가 이동 시 + 버튼 깜빡임 (결과 보고서 탭)
      _guideHighlightTimer: null,
    }
  },
  watch: {
    // 같은 라우터(EmergencyResponseTrainingDetail) 재진입 시 query._t로 분기 재실행
    '$route.query._t'(val, oldVal) {
      // 다른 라우트로 이동 시에도 keep-alive 잔존 컴포넌트의 watcher가 실행되므로 현재 라우트 가드
      if (this.$route.name !== 'EmergencyResponseTrainingDetail') return
      if (val && oldVal && val !== oldVal && this.$route.params?.data) {
        this.handleSemiannualRouteEntry()
      }
    },
    selectedKey: {
      deep: true,
      handler() {
        if (this.selectedKey == 0) {
          this.buttonUseList = [
            'btnSample', // 예시보기
            'btnSearch', //조회
            'btnSave', //저장
            'btnPrint',
            'btnDelete',
          ]
        } else {
          this.buttonUseList = [
            'btnSearch', //조회
            'btnSave', //저장
            'btnPrint',
            'btnDelete',
          ]
        }
        this.btnRefresh++
      },
    },
  },
  computed: {
    mobileTrigger: function () {
      return this.getWidth() < 1920
    },
    isCanEdit: function () {
      let editable = true
      // 시나리오의 서명이 완료된 상태이거나, 실시보고서 데이터가 있는 경우 수정 불가
      if (this.scenarioData.signWriterHrNo || this.scenarioData.signApproverHrNo || this.resultList.length > 0) editable = false
      return editable
    },
    breakpoint() {
      return this.$vuetify.breakpoint.name
    },
  },
  created() {},
  beforeMount() {},
  mounted() {
    this.initCompId = this.getCompId() // 초기 페이지 진입 시 compId 세팅
    if (!this.$route.params.data) {
      this.$router.go(-1)
      return
    }
    // 조회/탭 분기는 activated의 handleSemiannualRouteEntry에서 수행 (중복·조기 탭전환 방지)
  },
  beforeDestroy() {
    if (this._guideHighlightTimer) {
      clearTimeout(this._guideHighlightTimer)
      this._guideHighlightTimer = null
    }
  },
  async activated() {
    if (this.$route.name !== 'EmergencyResponseTrainingDetail') return
    if (this.changedCompFlag(this.initCompId) && !this.$route.params.data) {
      this.initCompId = this.getCompId()
      const toRouter = {
        name: 'EmergencyResponseTraining',
        params: {
          search: true,
        },
      }
      this.$router.push(toRouter)
      return
    }
    if (this.$route.params.data) {
      await this.handleSemiannualRouteEntry()
    }
  },
  methods: {
    /**
     * 동일 라우트(EmergencyResponseTrainingDetail) 내부 분기
     * - tabIndex 0: 매뉴얼 조회 후 서명 컴포넌트 강조
     * - tabIndex 1: 매뉴얼 전체 조회 완료 → 결과 보고서(1번) 탭 이동 → 서명영역 강조
     */
    async handleSemiannualRouteEntry() {
      const routeData = this.$route.params && this.$route.params.data
      if (!routeData) return
      if (this._loadingFromRoute) return
      this._loadingFromRoute = true

      try {
        this.mainData = routeData
        this.targetId = `${routeData.clntId}_${routeData.writeDt}_${routeData.docNo}`

        if (routeData.__created__) {
          this.targetId = ''
          await this.initializeData()
          if (routeData.guideHighlight) {
            this.startGuideHighlightByTabIndex(0)
          }
          return
        }

        const tabIndex = Number(routeData.tabIndex)

        // 1) 비상대응 매뉴얼(0번 탭) 데이터를 완전히 조회
        this.selectedKey = 0
        await this.loadManualTabData(routeData, true)

        if (tabIndex === 1) {
          // 2) 결과 보고서 목록도 미리 조회한 뒤 1번 탭으로 이동
          await this.loadResultTabData(routeData, true)
          this.selectedKey = 1
          await this.$nextTick()
          // resultTable 렌더 후 서명 강조가 보이도록 한 틱 더 대기
          await this.$nextTick()
          if (routeData.guideHighlight) {
            this.startGuideHighlightByTabIndex(1)
          }
        } else {
          await this.$nextTick()
          if (routeData.guideHighlight) {
            this.startGuideHighlightByTabIndex(0)
          }
        }
      } finally {
        this._loadingFromRoute = false
      }
    },
    // 비상대응 매뉴얼(0번 탭) 전체 조회: 시나리오 + 서명 + 훈련일자
    async loadManualTabData(params, notify = true) {
      this.targetId = `${params.clntId}_${params.writeDt}_${params.docNo}`
      this.resultData = { ...params }

      const res = await getEmergencyResponseTrainingScenario(params, notify)
      if (!res.code) this.scenarioData = _.clone(res)
      this.scenarioList = res.scenarioList ? res.scenarioList : []
      this.signatureList.scenario[0].data = this.scenarioData.signWriter ? this.scenarioData.signWriter : ''
      this.signatureList.scenario[0].userNm = this.scenarioData.signWriterNm ? this.scenarioData.signWriterNm : ''
      this.signatureList.scenario[1].data = this.scenarioData.signApprover ? this.scenarioData.signApprover : ''
      this.signatureList.scenario[1].userNm = this.scenarioData.signApproverNm ? this.scenarioData.signApproverNm : ''
      this.signatureList.scenario[2].data = this.scenarioData.signChecker ? this.scenarioData.signChecker : ''
      this.signatureList.scenario[2].userNm = this.scenarioData.signCheckerNm ? this.scenarioData.signCheckerNm : ''

      await this.$nextTick()
      if (this.$refs.iFileUploader) {
        this.$refs.iFileUploader.btnSearch()
      }

      const dateRes = await getTrainingResultDateList(res, false)
      if (dateRes.success && dateRes.list && dateRes.list.length > 0) {
        this.dateList = dateRes.list
      }
      return res
    },
    // 비상대응 결과 보고서 목록 조회
    async loadResultTabData(params, notify = true) {
      this.resultData = {
        ...this.resultData,
        ...params,
        searchStartDate: this.searchStartDate,
        searchEndDate: this.searchEndDate,
      }
      this.startDate = this.formatDate(this.searchStartDate)
      this.endDate = this.formatDate(this.searchEndDate)

      const res = await getEmergencyResponseTrainingResult(this.resultData, notify)
      if (res.success) {
        this.resultList = res.list || []
        this.resultList.__created__ = false
        this.signEditable = true
        this.resultList.forEach((el, index) => {
          el.index = index
          el.actionDt = this.formatDate(el.actionDt)
        })
      }
      return res
    },
    // tabIndex에 따른 가이드 하이라이트
    startGuideHighlightByTabIndex(tabIndex) {
      if (this._guideHighlightTimer) {
        clearTimeout(this._guideHighlightTimer)
        this._guideHighlightTimer = null
      }
      this.guideHighlightSign = false
      this.guideHighlightTab = false
      this.guideHighlightAdd = false

      this.$nextTick(() => {
        if (tabIndex === 1) {
          // 결과 보고서 탭: 서명영역(+ 버튼) 강조
          this.guideHighlightSign = true
          this.guideHighlightAdd = true
        } else {
          // 매뉴얼: 서명 컴포넌트
          this.guideHighlightSign = true
        }
        this._guideHighlightTimer = setTimeout(() => {
          this.guideHighlightSign = false
          this.guideHighlightTab = false
          this.guideHighlightAdd = false
          this._guideHighlightTimer = null
        }, 5000)
      })
    },
    functionEvents(date) {
      const [year, month, day] = date.split('-')
      if (this.dateList.includes(year + month + day)) return true
      return false
    },
    formatDate(date) {
      if (!date) return null

      if (date.indexOf('-') == -1) {
        const year = date.substring(0, 4)
        const month = date.substring(4, 6)
        const day = date.substring(6, 8)
        return `${year}-${month}-${day}`
      } else if (date.indexOf('-') > -1) {
        const [year, month, day] = date.split('-')
        return `${year}.${month}.${day}`
      } else {
        return date
      }
    },
    async signReset(type) {
      this.signatureList[type].forEach((el) => {
        el.data = ''
        el.userNm = ''
      })
      if (this.$refs[type]) await this.$refs[type].init()
      console.log(this.scenarioData)
    },
    async initializeData() {
      this.selectedKey = 0
      console.log('################# initializeData')
      this.scenarioData.clntId = this.getClntId()
      this.scenarioData.compId = this.getCompId()
      this.scenarioData.anticipatedDamage = ''
      this.scenarioData.writeDt = getCurrentDate().replaceAll('-', '')
      this.scenarioData.docNo = ''
      this.scenarioData.scenarioList = []
      this.scenarioData.trainingContent = ''
      this.scenarioData.trainingLocation = ''
      this.scenarioData.trainingNm = ''
      this.scenarioData.signApprover = null
      this.scenarioData.signApproverHrNo = null
      this.scenarioData.signApproverNm = null
      this.scenarioData.signChecker = null
      this.scenarioData.signCheckerHrNo = null
      this.scenarioData.signCheckerNm = null
      this.scenarioData.signWriter = null
      this.scenarioData.signWriterHrNo = null
      this.scenarioData.signWriterNm = null
      this.scenarioList = []
      this.mainData = {}
      this.scenarioData.__created__ = this.$route.params.data.__created__
      this.resultData = {}
      this.resultData.clntId = this.getClntId()
      this.resultData.compId = this.getCompId()
      this.resultData.writeDt = getCurrentDate().replaceAll('-', '')
      this.resultData.docNo = ''
      this.resultData.__created__ = this.$route.params.data.__created__
      this.resultList = []
      this.signEditable = false
      this.componentKey++
      await this.signReset('scenario')
    },
    ////////////////////////////////////////////
    // 버튼 클릭 이벤트
    ////////////////////////////////////////////
    async btnSearch(params, notify = true) {
      console.log('## search params => ', params)
      this.targetId = `${params.clntId}_${params.writeDt}_${params.docNo}`
      if (this.selectedKey == 0) {
        return this.loadManualTabData(params, notify)
      } else {
        return this.loadResultTabData(params, notify).then((res) => {
          this.$nextTick(() => {
            if (this.resultList.length > 0 && this.$refs.resultTable) {
              this.resultList.forEach((el, index) => {
                if (this.$refs.resultTable[index]) {
                  this.$refs.resultTable[index].btnFileSearch()
                  this.$refs.resultTable[index].getWorkerList()
                }
              })
            }
          })
          return res
        })
      }
    },
    checkHrNo() {
      let saveResultList = this.resultList.filter((el) => el.checked == true)
      if (saveResultList.length == 0) {
        this.vToastify(this.$t('확인할 데이터가 없습니다. 결과 보고서를 선택해주세요.'), 'info')
        return
      }
      this.openLoading()
      for (let i = 0; i < saveResultList.length; i++) {
        const param = {
          clntId: saveResultList[i].clntId,
          compId: saveResultList[i].compId,
          writeDt: saveResultList[i].writeDt,
          docNo: saveResultList[i].docNo,
          actionDt: saveResultList[i].actionDt,
        }
        checkEmergencyResponseTrainingResultLook(param, true)
          .then((res) => {
            let index = this.resultList.findIndex(
              (el) => el.writeDt == saveResultList[i].writeDt && el.docNo == saveResultList[i].docNo && el.actionDt == saveResultList[i].actionDt
            )
            // this.resultList[index].workerList = res.list
            this.$refs.resultTable[index].getWorkerList()
          })
          .catch(() => {
            this.endLoading()
          })
      }
      this.endLoading()
    },
    btnSave() {
      if (this.selectedKey == 0) {
        const validate = this.$refs.scenarioForm.validate()
        if (!validate) {
          this.vToastify(this.$t('저장 입력 항목을 확인해주세요.'), 'info')
          return
        }
        if (this.scenarioList.length === 0) {
          this.vToastify(this.$t('행동 요령을 추가해주세요.'), 'info')
          return
        }
        let saveSuccess = false
        this.vToastifyPrompt(this.$t('저장하시겠습니까?'), 'info', async (current) => {
          this.openLoading()
          this.scenarioData.scenarioList = _.clone(this.scenarioList)
          console.log('############ save', this.scenarioData)
          saveEmergencyResponseTrainingScenario(this.scenarioData, true)
            .then((res) => {
              if (res.success) {
                //첨부파일 처리를 위한 flag
                saveSuccess = true
                this.scenarioData.docNo = res.map.docNo
                this.scenarioData.__created__ = false
                this.resultData.docNo = res.map.docNo
                this.mainData = _.clone(this.scenarioData)
                this.targetId = res.map.targetId
                this.endLoading()
              }
              // this.btnSearch(this.mainData, false)
            })
            .finally(() => {
              if (saveSuccess && (this.fileList.insert.length !== 0 || this.fileList.delete.length !== 0)) {
                this.$refs.iFileUploader.btnSave(this.fileList)
                this.fileList = {
                  insert: [],
                  delete: [],
                }
              }
              this.signEditable = true
              this.componentKey++
              this.endLoading()
            })
        })
      } else {
        let validCount = 0
        let actionDtDuplicated = false
        let saveResultList = this.resultList.filter((el) => el.checked == true)
        if (!this.scenarioData.signWriterHrNo || !this.scenarioData.signApproverHrNo) {
          this.vToastify(this.$t('비상대응 매뉴얼가 승인되지 않았습니다. 서명을 완료해주세요.'), 'info')
          return
        }
        if (saveResultList.length == 0) {
          this.vToastify(this.$t('저장할 데이터가 없습니다. 결과 보고서를 선택해주세요.'), 'info')
          return
        }
        if (saveResultList.length > 0) {
          saveResultList.forEach((el, idx) => {
            if (el.checked) {
              // 저장 유효성 검사
              if (validCount == 0) validCount += this.$refs.resultTable[saveResultList[idx].index].btnSave()
            }
          })

          if (validCount == 0) {
            let params = []
            saveResultList.forEach((el, idx) => {
              if (el.checked) {
                params.push(this.$refs.resultTable[saveResultList[idx].index].editingData)
              }
            })
            console.log('################ 저장로직 수행 ################')
            console.log(params, saveResultList)
            if (params.length == 0) {
              this.vSnackbar(this.$t('저장할 데이터가 없습니다.'), 'warn')
              return
            }

            let legacyData = this.resultList.filter((el) => !el.__created__)
            params.forEach((saveData) => {
              let duplicatedData = legacyData.filter(
                (legacy) => legacy.actionDt.replaceAll('-', '') === saveData.actionDt.replaceAll('-', '') && saveData.__created__
              )
              console.log('######## duplicated', duplicatedData)
              if (duplicatedData.length > 0) actionDtDuplicated = true
            })
            if (actionDtDuplicated) {
              this.vSnackbar(this.$t('훈련일자는 중복될 수 없습니다.'), 'warn')
              return
            }
            console.log('@@ params', params)
            this.vToastifyPrompt(this.$t('저장하시겠습니까?'), 'info', async (current) => {
              this.openLoading()
              saveEmergencyResponseTrainingResult(params, true)
                .then((res) => {
                  console.log('## res', res)
                  params.forEach((el, idx) => {
                    this.$refs.resultTable[saveResultList[idx].index].btnFileSave(el)
                  })
                })
                .finally(() => {
                  this.endLoading()
                  this.btnSearch(params)
                })
            })
          }
        }
      }
    },
    btnDelete() {
      if (this.selectedKey == 0) {
        console.log('############## scenarioData', this.scenarioData)
        if (!this.scenarioData?.docNo) {
          this.vSnackbar(this.$t('삭제할 비상대응 매뉴얼가 없습니다.'), 'warn')
          return
        }
        if (this.dateList.length > 0) {
          this.vSnackbar(this.$t('비상훈련 실시 횟수가 1회 이상인 시나리오는 삭제할 수 없습니다.'), 'warn')
          return
        }
        // if (this.scenarioData.signWriterHrNo || this.scenarioData.signApproverHrNo) {
        //   this.vSnackbar(this.$t('서명이 완료된 시나리오는 삭제할 수 없습니다.'), 'warn')
        //   return
        // }
        this.vToastifyPrompt('대응훈련 시나리오를 삭제하시겠습니까?', 'info', (current) => {
          this.openLoading()
          deleteEmergencyResponseTraining([this.scenarioData], true)
            .then((res) => {
              console.log('## 삭제', res)
              const toRouter = {
                name: 'EmergencyResponseTraining',
                params: {
                  search: true,
                },
              }
              this.$router.push(toRouter)
            })
            .catch(() => {
              this.endLoading()
            })
            .finally(() => {
              console.log('### this.scenarioData[0]', this.scenarioData)
              let deleteParams = {
                clntId: this.scenarioData.clntId,
                targetType: '00012',
                targetId: `${this.scenarioData.clntId}_${this.scenarioData.writeDt}_${this.scenarioData.docNo}`,
              }
              this.endLoading()
              this.$refs.iFileUploader.btnDelete(deleteParams)
            })
        })
      } else {
        let validCount = 0
        let deleteResultList = this.resultList.filter((el) => el.checked == true)
        if (deleteResultList.length == 0) {
          this.vToastify(this.$t('삭제할 결과 보고서가 없습니다. 결과 보고서를 선택해주세요.'), 'info')
          return
        }
        if (deleteResultList.length > 0) {
          deleteResultList.forEach((el, idx) => {
            if (el.checked) {
              // 삭제 유효성 검사
              if (validCount == 0) validCount += this.$refs.resultTable[deleteResultList[idx].index]?.btnDelete()
            }
          })
          if (validCount == 0) {
            let params = []
            deleteResultList.forEach((el, idx) => {
              if (el.checked) {
                params.push(this.$refs.resultTable[deleteResultList[idx].index].editingData)
              }
            })
            console.log('################ 삭제로직 수행 ################')

            this.vToastifyPrompt(this.$t('삭제하시겠습니까?'), 'info', async (current) => {
              this.openLoading()
              deleteEmergencyResponseTrainingResult(params, true)
                .then((res) => {
                  console.log('## res', res)
                  params.forEach((el, index) => {
                    this.$refs.resultTable[index].btnFileDelete()
                    let dateIndex = this.duplicatedActDt.findIndex((el) => el === params.actionDt)
                    if (dateIndex > -1) this.duplicatedActDt.splice(dateIndex, 1)
                  })
                  // this.btnSearch(params)
                })
                .catch(() => {
                  this.endLoading()
                })
                .finally(() => {
                  for (let index = params.length; index > 0; index--) {
                    this.resultList.splice(index, 1)
                  }
                  this.btnSearch(params)
                  this.endLoading()
                })
            })
          }
        }
        // this.$refs.resultTable.btnDelete()
      }
    },
    btnPrint(type) {
      if (this.selectedKey == 0) {
        if (this.scenarioData.docNo) {
          if (!this.scenarioData.signApprover) {
            this.vSnackbar(this.$t('승인자의 서명이 완료된 문서만 출력이 가능합니다.'), 'warn')
            return
          }
          this.openLoading()
          let params = {
            clntId: this.getClntId(),
            compId: this.getCompId(),
            writeDt: this.scenarioData.writeDt,
            docNo: this.scenarioData.docNo,
            type: type,
          }
          getTrainingScenarioReport(params)
            .then((res) => {
              this.downloadReport(res, '비상대응 매뉴얼 -' + this.scenarioData.trainingNm + '.' + type)
            })
            .catch(() => {
              this.endLoading()
            })
            .finally(() => {
              this.endLoading()
            })
        } else {
          this.vSnackbar(this.$t('출력할 시나리오가 없습니다.'), 'warn')
          return
        }
      } else {
        let saveResultList = this.resultList.filter((el) => el.checked == true)
        if (saveResultList.length === 0) {
          this.vSnackbar(this.$t('출력할 결과 보고서가 없습니다. 결과 보고서를 선택해주세요.'), 'info')
          return
        }
        // let valCheck = saveResultList.filter((el) => !el.signApprover)
        // if (valCheck.length > 0) {
        //   this.vSnackbar(this.$t('승인자의 서명이 완료된 문서만 출력이 가능합니다.'), 'warn')
        //   return
        // }
        let params = {
          clntId: this.getClntId(),
          compId: this.getCompId(),
          compNm: this.getCompNm(),
          writeDt: this.resultData.writeDt,
          docNo: this.resultData.docNo,
          type: type,
        }

        this.openLoading()
        getTrainingResultReport(params)
          .then((res) => {
            this.downloadReport(res, '비상대응 결과보고서 -' + this.scenarioData.trainingNm + '.' + type)
          })
          .catch(() => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
          })
      }
    },
    btnSampleLoad() {
      if (this.resultList.length > 0 || this.scenarioData.signWriterHrNo || this.scenarioData.signCheckerHrNo || this.scenarioData.signApproverHrNo) {
        this.vSnackbar(this.$t('서명이 완료된 문서입니다. 예시를 불러올 수 없습니다.'), 'warn')
        return
      }
      this.vToastifyPrompt(this.$t('작성중인 내용이 덮어집니다. 예시를 불러오시겠습니까?'), 'info', async (current) => {
        getTrainingScenarioSampleData({}, true)
          .then((res) => {
            const compNm = this.getCompNm()
            this.scenarioData.anticipatedDamage = res.anticipatedDamage
            this.scenarioList = res.scenarioList
            this.scenarioData.trainingContent = res.trainingContent
            this.scenarioData.trainingLocation = compNm + ' ' + res.trainingLocation
            this.scenarioData.trainingNm = res.trainingNm
            this.scenarioData.signApprover = ''
            this.scenarioData.signApproverHrNo = ''
            this.scenarioData.signChecker = ''
            this.scenarioData.signCheckerHrNo = ''
            this.scenarioData.signWriter = ''
            this.scenarioData.signWriterHrNo = ''
            this.signReset('scenario')
          })
          .finally(() => {
            this.scenarioList.forEach((el) => {
              el.clntId = this.getClntId()
              el.compId = this.getCompId()
              el.writeDt = this.scenarioData.writeDt
              el.docNo = this.scenarioData.docNo
              el.targetTime = parseInt(el.targetTime)
            })
          })
        return
      })
    },
    btnCancel() {
      this.vToastifyPrompt(this.$t('작성을 중지하고 이전 페이지로 이동하시겠습니까?'), 'info', async (current) => {
        this.scenarioData.signApprover = ''
        this.scenarioData.signApproverHrNo = ''
        this.scenarioData.signChecker = ''
        this.scenarioData.signCheckerHrNo = ''
        this.scenarioData.signWriter = ''
        this.scenarioData.signWriterHrNo = ''
        const toRouter = {
          name: 'EmergencyResponseTraining',
          params: {
            search: true,
          },
        }
        this.$router.push(toRouter)
        this.signReset('scenario')
        return
      })
    },

    ////////////////////////////////////////////
    // 이벤트 함수
    ////////////////////////////////////////////
    signChanged(data) {
      if (data.subMenu == 'scenario') {
        // if (!data.isSign && this.resultList.length > 0) {
        //   this.vSnackbar(this.$t(`비상대응 결과 보고서가 ${this.resultList.length}건 존재하여 서명 수정이 불가합니다.`), 'warn')
        //   this.componentKey++
        //   return
        // }
        console.log('@@@ data', this.resultList)
        data.isSign ? (this.scenarioData[data.headerCd] = data.hrNo) : (this.scenarioData[data.headerCd] = '')
        if (this.scenarioData.docNo) {
          updateScenarioSign(this.scenarioData).then((res) => {
            //
          })
        }
      } else if (data.subMenu == 'implementationReport') {
        let saveData = this.$refs.resultTable[data.index].editingData
        data.isSign ? (saveData[data.headerCd] = data.hrNo) : (saveData[data.headerCd] = '')
        console.log('@@@ save', saveData)
        if (saveData.docNo && !saveData.__created__) {
          updateResultSign(saveData).then((res) => {
            //
            this.$refs.resultTable[data.index].editingData.__created__ = false
          })
          this.resultList[data.index] = saveData
        }
      }
      // this.componentKey++
    },
    addScenario() {
      console.log('########### resultList', this.resultList.length)
      if (this.scenarioData.signWriterHrNo || this.scenarioData.signCheckerHrNo || this.scenarioData.signApproverHrNo) {
        this.vSnackbar(this.$t('서명이 완료된 시나리오는 내용만 수정이 가능합니다.'), 'warn')
        return
      }
      this.scenarioList.push({
        clntId: this.getClntId(),
        compId: this.getCompId(),
        writeDt: this.scenarioData.writeDt,
        docNo: this.scenarioData.docNo,
        targetTime: 1,
        methodAction: '',
        remark: '',
      })
    },
    subtractScenario(index) {
      if (this.scenarioData.signWriterHrNo || this.scenarioData.signCheckerHrNo || this.scenarioData.signApproverHrNo) {
        this.vSnackbar(this.$t('서명이 완료된 시나리오는 내용만 수정이 가능합니다.'), 'warn')
        return
      }
      if (index == 'clearAll') {
        this.scenarioList = []
        return
      }
      this.scenarioList = this.scenarioList.filter((element) => element != this.scenarioList[index])
    },
    addResult() {
      console.log('### add', this.resultList)
      this.resultList.push({
        clntId: this.getClntId(),
        compId: this.getCompId(),
        writeDt: this.scenarioData.writeDt,
        docNo: this.scenarioData.docNo,
        trainingNm: this.scenarioData.trainingNm,
        targetTime: this.scenarioList[this.scenarioList.length - 1].targetTime,
        methodAction: '',
        remark: '',
        checked: true,
        index: this.resultList.length,
        __created__: true,
      })
    },
    subtractResult(index) {
      // if (this.resultList[index].signWriterHrNo || this.resultList[index].signApproverHrNo) {
      //   this.vSnackbar(this.$t('서명이 완료된 보고서는 내용만 수정이 가능합니다.'), 'warn')
      //   return
      // }
      this.vToastifyPrompt(this.$t('삭제하시겠습니까?'), 'info', async (current) => {
        if (this.resultList[index].__created__) this.resultList.splice(index, 1)
        else {
          this.openLoading()
          deleteEmergencyResponseTrainingResult([this.resultList[index]], true)
            .then((res) => {
              this.$refs.resultTable[index].btnFileDelete()
              let dateIndex = this.duplicatedActDt.findIndex((el) => el === this.resultList[index].actionDt)
              if (dateIndex > -1) this.duplicatedActDt.splice(dateIndex, 1)
              this.resultList.splice(index, 1)
            })
            .finally(() => {
              // this.btnSearch(this.resultList[index])
              this.endLoading()
            })
        }
      })
    },
    subMenuChanged(index) {
      if ((index == 1 && !this.scenarioData.signWriterHrNo) || !this.scenarioData.signApproverHrNo) {
        // this.vToastifyPrompt(this.$t('비상대응 결과 보고서는 비상대응 매뉴얼 결재가 완료되어야 작성 가능합니다. 시나리오를 작성하시겠습니까? '), 'warn', async current => {
        //   this.subMenuChanged(0)
        // })
        this.vSnackbar(this.$t('비상대응 결과 보고서는 비상대응 매뉴얼 결재가 완료되어야 작성 가능합니다.'), 'warn')
        this.selectedKey = 0
        return
      }
      this.selectedKey = index
      // this.signEditable = true
      if (this.selectedKey == 0) {
        // 비상대응 매뉴얼
        this.resultList = []
        getEmergencyResponseTrainingScenario(this.scenarioData, true).then((res) => {
          console.log('############ 서브메뉴 변경 res', res)
          if (!res.code) this.scenarioData = _.clone(res)
          this.scenarioList = res.scenarioList ? res.scenarioList : []
          this.signatureList.scenario[0].data = this.scenarioData.signWriter ? this.scenarioData.signWriter : ''
          this.signatureList.scenario[0].userNm = this.scenarioData.signWriterNm ? this.scenarioData.signWriterNm : ''
          this.signatureList.scenario[1].data = this.scenarioData.signApprover ? this.scenarioData.signApprover : ''
          this.signatureList.scenario[1].userNm = this.scenarioData.signApproverNm ? this.scenarioData.signApproverNm : ''
          this.signatureList.scenario[2].data = this.scenarioData.signChecker ? this.scenarioData.signChecker : ''
          this.signatureList.scenario[2].userNm = this.scenarioData.signCheckerNm ? this.scenarioData.signCheckerNm : ''
          this.$refs.iFileUploader.btnSearch()
          //
          getTrainingResultDateList(res, false).then((res) => {
            if (res.success) {
              if (res.list.length > 0) {
                this.dateList = res.list
                // this.signEditable = false
              }
              // else this.signEditable = true
            }
          })
        })
        return
      }
      this.resultData.searchStartDate = this.searchStartDate
      this.resultData.searchEndDate = this.searchEndDate
      this.startDate = this.formatDate(this.searchStartDate)
      this.endDate = this.formatDate(this.searchEndDate)
      getEmergencyResponseTrainingResult(this.resultData, true).then((res) => {
        if (res.success) {
          this.resultList = res.list
          if (this.resultList.length > 0) {
            this.resultList.forEach((el, index) => {
              el.index = index
              this.$refs.resultTable[index].btnFileSearch()
            })
          }
          getTrainingResultDateList(this.resultData, false).then((res) => {
            if (res.success) {
              this.duplicatedActDt = []
              this.dateList = res.list
              res.list.forEach((el) => {
                const year = el.substring(0, 4)
                const month = el.substring(4, 6)
                const day = el.substring(6, 8)
                this.duplicatedActDt.push(`${year}-${month}-${day}`)
              })
            }
          })
        }
      })
    },
    ////////////////////////////////////////////
    // 이벤트 함수
    ////////////////////////////////////////////
    onFileChanged(fileList) {
      this.fileList = fileList
    },
    checkResult(index, checked) {
      this.resultList[index] = _.clone(this.$refs.resultTable[index].editingData)
      this.resultList[index].checked = checked
    },
    setSearchDate(e, div) {
      console.log('@@@ e, div', e, div)
      if (e.length >= 10) {
        if (div === 'start') {
          this.searchMinDate = e
          this.searchStartDate = e.replace(/[^0-9]/g, '')
        } else if (div === 'end') {
          this.searchMaxDate = e
          this.searchEndDate = e.replace(/[^0-9]/g, '')
        }
        this.btnSearch(this.resultData)
      }
    },
    onValueChanged(e, index) {
      if (e < 0) this.scenarioList[index].targetTime = 0
    },
    // 훈련알림 발송
    btnTrainingFcm() {
      this.vToastifyPrompt(`사업장에 속한 모든 인원에게 <br/> '${this.scenarioData.trainingNm}' 훈련 알림을 발송하시겠습니까?`, 'info', (current) => {
        this.openLoading()
        const actionContent = '훈련 내용\n' + this.scenarioData.trainingContent + `\n`
        const trainingResult =
          '\n훈련 결과\n' +
          ' - 최초 발견자의 119 신고 절차 확인\n' +
          ' - 현장 통제 및 대피 절차 확인\n' +
          ' - 응급조치 및 구조 절차 확인\n' +
          ' - 상황보고 체계 확인'
        const param = {
          clntId: this.scenarioData.clntId,
          compId: this.scenarioData.compId,
          writeDt: this.scenarioData.writeDt,
          docNo: this.scenarioData.docNo,
          actionNm: this.scenarioData.trainingNm,
          actionContent: actionContent + trainingResult,
          actionLocation: this.scenarioData.trainingLocation,
        }
        sendFCMTraining(param)
          .then((res) => {
            this.vSnackbar(this.$t('훈련 알림 발송이 완료되었습니다.'), 'info', 2000)
            //
          })
          .catch(() => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
          })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.tableTitle {
  width: 10%;
}

.right-aligned input {
  text-align: right !important; /* 입력 필드 내용을 오른쪽으로 정렬 */
}

@keyframes guide-blink-red {
  0%,
  100% {
    box-shadow: inset 0 0 0 0 transparent;
    outline: 2px solid transparent;
    background-color: transparent;
  }
  50% {
    box-shadow: inset 0 0 0 2px rgba(244, 67, 54, 0.85);
    outline: 2px solid #f44336;
    background-color: rgba(244, 67, 54, 0.12);
  }
}

.guide-blink-target {
  animation: guide-blink-red 0.8s ease-in-out 5;
  border-radius: 8px;
}
</style>
